export const CONVERSATIONAL_MM_WIDGET_TOOL_LABELS = {
    spendGoals: 'Spend & Goals',
    multiSelect: 'Multi-Select',
    savingsGoals: 'Savings Goals',
    draftedMessage: 'Drafted Message',
    savingsGoalAmounts: 'Savings Goal Amounts',
    incomeInput: 'Income Input',
} as const;

export const CONVERSATIONAL_MM_INTERACTIVE_WIDGET_TOOL_LABELS: readonly string[] =
    [
        CONVERSATIONAL_MM_WIDGET_TOOL_LABELS.spendGoals,
        CONVERSATIONAL_MM_WIDGET_TOOL_LABELS.multiSelect,
        CONVERSATIONAL_MM_WIDGET_TOOL_LABELS.draftedMessage,
        CONVERSATIONAL_MM_WIDGET_TOOL_LABELS.savingsGoalAmounts,
        CONVERSATIONAL_MM_WIDGET_TOOL_LABELS.incomeInput,
    ];
